export default __webpack_public_path__ + "static/SpringThree-3a4d56519c8a0069227ed2974afeb63a.webp";